/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salty_Blue_Macaw_PullInputs */

const fr_salty_blue_macaw_pull = /** @type {(inputs: Salty_Blue_Macaw_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout réduire`)
};

/**

* @param {Salty_Blue_Macaw_PullInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const salty_blue_macaw_pull = /** @type {((inputs?: Salty_Blue_Macaw_PullInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salty_Blue_Macaw_PullInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_salty_blue_macaw_pull(inputs)
});